// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__pcbKr","calendarButtons":"ClockData_calendarButtons__1ODwH"};